module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG29dc6e5320c8e8163f34b17e7c516e14.29dc6e53.png";